//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'DetailInfo',
  props: {
    list: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  }
};